import script from "./LazyImage.vue?vue&type=script&lang=ts&setup=true"
export * from "./LazyImage.vue?vue&type=script&lang=ts&setup=true"

import "./LazyImage.vue?vue&type=style&index=0&id=de15f490&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-de15f490"]])

export default __exports__